import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Button,
  Checkbox,
  Popconfirm,
  notification,
  Popover,
  Modal,
  Radio,
  Dropdown,
  Menu,
} from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import styles from './newCommodity.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../compnents/nav/NavBar'
import { getCommodityDetail, getShopGoodsNo, getSyncInventoryAsync, getZjWbCodes, logoutOrenableCommodity, selectCommodityDetail, selectCommodityId, selectShopNo, setCommodityDetail, setCurrent, setSelectId, saveCommodityAsync } from '../commodity/commoditySlice'
import { selectInsuranceArray, selectTenantCategory, selectTenantCityCode } from '../../app/applicationSlice'
import { useHistory, useLocation } from 'react-router-dom'
import { RecipeItemInput } from '../commodity/componment/RecipeItemInput'
import { getCommonCodeCompletions, ItemCompletionType, selectCommonCodes } from '../completion/completionSlice'
import { CaretDownFilled, CaretUpFilled, CheckCircleOutlined, CloseOutlined, ExclamationCircleFilled, SettingOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../app/store'
import { getChrgitmLvName, getMaterialsName, Materiales } from '../../models/commodity'
import { CommonCodeCategory } from '../../models/commoncode'
import { BillingCategoryName, InvoiceBillingCategories } from '../../models/billingCategory'
import DrugImg from './image/drug.png'
import { RecipeItemFieldInput } from '../treatment/editor/components/RecipeItemFieldInput'
import { MedicalModal } from '../commodity/medical/MedicalModal'
import QuestionTipsImg from '../../compnents/icons/png/questionTips.png'
import { SupplierModal } from '../savebusiness/modal'
import { SupplierModal as SupplierSaveModal } from '../wms/modal'
import { selectSettings } from '../user/setting/settingSlice'
import { Checks } from '../../models/setting'
import ElseImg from './image/else.png'


const { Option } = Select
const { TextArea } = Input
const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 22 },
}

const firstColumnLayout = {
  labelCol: {
    flex: '0 0 6rem',
  },
}

const titleColumnLayout = {
  labelCol: {
    flex: '0 0 9rem',
  },
}

export const NewMaterialsSaveform = (props: {
  billingCategory?: any
  hilistCode?: any
  mappingId?: any
  flag?: any
  materialCategory?: any //类别
  details?: any //码上放心过来的
  refresh?: (v?: any) => void
}): ReactElement => {

  const [form] = Form.useForm()

  const location: any = useLocation()

  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const cityCode = useSelector(selectTenantCityCode)

  const drugMarkCodeRef = useRef<any>(null) //商品标识码输入框

  const minPackNumsRef = useRef<any>(null) //最小包装数量输入框

  const minPackUnitRef = useRef<any>(null) //最小包装单位输入框

  const accountUnitRef = useRef<any>(null) //账簿单位输入框

  // props?.materialCategory 一般是码上放心弹窗过来的
  const materialCategory = location?.state?.materialCategory?.toString() ? location?.state?.materialCategory : props?.materialCategory

  const settings = useSelector(selectSettings)

  const shopNo = useSelector(selectShopNo)

  const selectId = useSelector(selectCommodityId)

  const detail: any = useSelector(selectCommodityDetail)

  const insuranceArray = useSelector(selectInsuranceArray)

  const tenantCategory = useSelector(selectTenantCategory)  // 17 校医务室 不展示进价售价

  const DWdata = useSelector(selectCommonCodes(CommonCodeCategory.Unit)) //账簿单位

  const [source, setSource] = useState(0)

  const [open, setOpen] = useState(false)

  const [tenantSupplierId, setTenantSupplierId] = useState(0)

  const [sourceMaterialsCatalogId, setSourceMaterialsCatalogId] = useState()

  const [writeBack, setWriteBack] = useState(false)

  const [isSubmitLoading, setIsSubmitLoading] = useState<any>(false) //提交loading

  const [saveAndContinue, setSaveAndContinue] = useState<any>(false) //是否保存并继续

  const [medicalModalVisible, setMedicalModalVisible] = useState(false) //医保目录弹窗

  const [medicalModalInfo, setMedicalModalInfo] = useState<any>() //医保目录信息

  const [isModalVisible, setIsModalVisible] = useState(false) //生产厂家供应商弹窗选择

  const [isAddModalVisible, setIsAddModalVisible] = useState(false) //是否添加生产厂家

  const [extendInformation, setExtendInformation] = useState<any>() //扩展信息箭头

  const [drugMarkCCodePlaceholder, setDrugMarkCCodePlaceholder] = useState('') //商品标识码(占位符

  const [showGLButton, setShowGLButton] = useState(false) //商品标识码(输入展示关联按钮

  const [YPBSMValue, setYPBSMValue] = useState('')

  const [isSPBSMVisible, setIsSPBSMVisible] = useState(false) //是否展示商品标识码弹窗

  const [drugMarkCCodeList, setDrugMarkCCodeList] = useState<any[]>([]) //商品标识码关联列表

  const [splitTag, setSplitTag] = useState(false) //是否拆零

  const [isChecked, setIsChecked] = useState<any>(false) //是否生成调价记录

  const [loading, setLoading] = useState(false) //同步售价到库存弹窗loading

  const [sureVisible, setSureVisible] = useState(false) //同步售价到库存弹窗

  const [memberDiscountType, setMemberDiscountType] = useState(0) // 会员价折扣类型：0折扣 1特价

  const [cachedSpecialPrice, setCachedSpecialPrice] = useState<any>(null)

  const [cachedDiscountPrice, setCachedDiscountPrice] = useState<any>(null)

  useEffect(() => {
    if (!localStorage.getItem('time2')) {
      localStorage.setItem('time2', JSON.stringify(new Date()))
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [])

  useEffect(() => {
    if (sureVisible) {
      const SFSCBDJLHTJJL = localStorage?.getItem('SFSCBDJLHTJJL')
      setIsChecked(SFSCBDJLHTJJL == 'true' ? true : false)
    }
  }, [sureVisible])

  // 类别回填
  useEffect(() => {
    form.setFieldsValue({
      materialsCategory: materialCategory,
    })
  }, [materialCategory])

  // 初次默认进来清数据
  useEffect(() => {
    return () => {
      resetForm()
    }
  }, [])

  const resetForm = () => {
    form.resetFields()
    setComponentItem(undefined)
    dispatch(setSelectId(0))
    dispatch(setCommodityDetail({}))
    setSplitTag(false)
    setDrugMarkCCodeList([])
    setShowGLButton(false)
    setDrugMarkCCodePlaceholder('')
    setMedicalModalInfo({})
    setExtendInformation(false)
  }

  // 回填数据
  useEffect(() => {
    if (JSON.stringify(detail) !== '{}') {
      setFileds(detail, true)
    } else if (props?.details && JSON.stringify(props?.details) !== '{}') {
      setFileds(props?.details, false)
    } else {
      const drugCategory = form.getFieldValue('drugCategory') || '材料'
      // 新增默认值
      form.setFieldsValue({
        noTraceCodeFlag: '0', //药品标识码  (有码)
        drugCategory: drugCategory, //药品分类 (有选中的就是选中的 没有就是第一个)
        billingCategory: '17', //开票项目
      })
    }
  }, [detail, props?.details])

  // 编辑回填
  const setFileds = (detail?: any, flag?: boolean) => {
    const hilistName = detail?.mixInsuranceCatalog?.hilistName
    const chrgitmLv = detail?.mixInsuranceCatalog?.chrgitmLv
    const memberInterestVO = detail?.memberInterestVO || {}

    form.setFieldsValue({
      ...detail,
      ...detail?.mixInsuranceCatalog,
      ...detail?.materialsCatalogPlus,
      spec: detail?.spec || '', //规格
      retailPrice: flag ? (detail?.retailPrice == -1 ? '' : detail?.retailPrice == -1 ? '' : detail?.retailPrice) : '',//售价/元
      splitTag: detail?.splitTag > 0 ? true : false, //允许拆零
      splitPrice: detail?.splitPrice > 0 ? detail?.splitPrice : '', //拆零售价/元
      stockPrice: detail?.stockPrice < 0 ? '' : detail?.stockPrice, //进价/元

      forceYearAccount: Number(detail?.forceYearAccount) > 0 ? Number(detail?.forceYearAccount) : 0, //医保结算方式
      hilistName: (hilistName ? hilistName : '') + (chrgitmLv ? (' [' + getChrgitmLvName(chrgitmLv) + '] ') : ''), //医保名称 + 甲乙分类
      rewriteHilistCode: detail?.rewriteHilistCode, //自定义医保国码
      proviceHilistCode: detail?.proviceHilistCode || '', //医保省市编码
      discountType: memberInterestVO?.discountType === -1 ? 0 : (memberInterestVO?.discountType ?? 0),
      memberPrice: memberInterestVO?.price === -1
        ? undefined
        : memberInterestVO?.discountType === 1 && memberInterestVO?.price != null
          ? Number(memberInterestVO.price).toFixed(5)
          : memberInterestVO?.price,
    })
    setMemberDiscountType(memberInterestVO?.discountType === -1 ? 0 : (memberInterestVO?.discountType ?? 0))
    if (memberInterestVO?.discountType === 1 && memberInterestVO?.price != null && memberInterestVO?.price !== -1) {
      setCachedSpecialPrice(Number(memberInterestVO.price).toFixed(5))
    }
    setSplitTag(detail?.splitTag == -1 ? '' : detail?.splitTag)
    setTenantSupplierId(detail?.tenantSupplierId)

    // 码上放心
    if (props?.flag == '/msfxFlag') {
      getZjWbCodesAsync(detail?.name)
    }

    // 医保信息
    const hilistPricUplmtAmt = detail?.mixInsuranceCatalog?.hilistPricUplmtAmt
    setMedicalModalInfo({
      ...detail,
      ...detail?.mixInsuranceCatalog,
      aprvno: detail?.mixInsuranceCatalog?.aprvno || detail?.approvalNumber, //批准文号
      hilistPricUplmtAmt: hilistPricUplmtAmt >= 99999 ? 0 : hilistPricUplmtAmt, //医保限价
    })
    // 跟下拉回填的公共部分
    commonSetFiles({ ...detail, ...detail?.materialsCatalogPlus })
  }

  // 下拉回填
  const recipeItemInputSetFileds = (m: any) => {
    const no = form.getFieldValue('no')
    form.setFieldsValue({
      ...m,
      tax: m?.tax == -1 ? '' : m?.tax,
      no: m.no == '' ? no : m.no, //商品编码
      source: 1,
      allStr: m.name,
      splitTag: 0, //是否拆零
      billingCategory: m.billingCategory.toString(),
      drugCategory: m.drugCategory, //分类
      stockPrice: null, //进价/元
      forceYearAccount: 0, //医保结算方式
      retailPrice: '', //售价/元
      splitPrice: m?.splitPrice > 0 ? m?.splitPrice : '', //拆零售价/元
    })
    setSplitTag(false)
    commonSetFiles({ ...m, ...m?.materialsCatalogPlus })
  }

  const commonSetFiles = (m?: any) => {

    setComponentItem({
      name: m?.name,
      billingCategory: m?.billingCategory,
      tenantSupplierName: m?.tenantSupplierName,
      approvalNumber: m?.approvalNumber,
    })
    form.setFieldsValue({
      drugMarkCode: '', //药品标识码
      minPackNums: m?.minPackNums > 0 ? m?.minPackNums : '', //最小包装数量
      minPackUnit: m?.minPackUnit || '', //最小包装单位
      noTraceCodeFlag: m?.noTraceCodeFlag < 0 ? '0' : (m?.noTraceCodeFlag)?.toString(), //药品标识码
      tax: m?.tax > 0 ? m?.tax : '', //项目税率
      limitCount: m?.limitCount > 0 ? m?.limitCount : '', //医保限量开方
    })
    setDrugMarkCCodeList(m?.drugMarkCode ? m?.drugMarkCode?.split(',') : []) //药品标识码
  }

  // 获取药品编码
  useEffect(() => {
    if (!selectId) {
      dispatch(getShopGoodsNo())
    }
  }, [selectId])

  // 回填药品编码
  useEffect(() => {
    if (shopNo) {
      form.setFieldsValue({
        no: shopNo,
      })
    }
  }, [shopNo])

  const [componentItem, setComponentItem] = useState<any>({
    name: '',
    billingCategory: '',
    tenantSupplierName: '',
    approvalNumber: '',
  })

  useEffect(() => {
    dispatch(getCommonCodeCompletions(CommonCodeCategory.Unit, ''))
  }, [])

  useEffect(() => {
    if (selectId) {
      const billingCategory = location.state?.record?.billingCategory || props?.billingCategory || ''
      const hilistCode = location.state?.record?.hilistCode || props?.hilistCode || ''
      const mappingId = location.state?.record?.mappingId || props?.mappingId || ''
      const insuranceCode = location.state?.record?.insuranceCode || insuranceArray?.[0]?.insuranceCode || ''
      const insuAdmdvs = insuranceArray?.[0]?.insuranceCuntryCode || ''
      dispatch(
        getCommodityDetail({
          id: selectId,
          billingCategory: billingCategory,
          hilistCode: hilistCode,
          insuranceCode: insuranceCode,
          mappingId: mappingId,
          insuAdmdvs: insuAdmdvs,
        })
      )
    }
  }, [selectId])

  // 物资名称输入获取
  const getWubi = (e: any) => {
    getZjWbCodesAsync(e)
    setComponentItem({
      ...componentItem,
      name: e,
    })
  }

  // 商品标识码overlay
  const spbsmOverlay = (
    <Menu>
      <div
        className={styles.spbsmOverlayContent}>
        <div style={{ color: '#999999' }}>已关联 {drugMarkCCodeList?.length} 个</div>
      </div>
      {drugMarkCCodeList?.map((v: any) => {
        return (
          <div
            key={v}
            className={styles.spbsmOverlayContent}
            onClick={() => {
              return
            }}
          >
            <div>{v}</div>
            <div>
              <CloseOutlined
                style={{ color: '#999999' }}
                onClick={() => {
                  setDrugMarkCCodeList(
                    drugMarkCCodeList?.filter((item: any) => item != v)
                  )
                }}
              /></div>
          </div>
        )
      })}
    </Menu>
  )

  // 医保匹配
  const matching = () => {
    if (!insuranceArray?.length) {
      notification.error({ message: '请先开通医保！' })
      return
    }

    if (!componentItem.name || !componentItem.billingCategory) {
      notification.error({ message: '请先完善材料基本信息！' })
      return
    }

    setWriteBack(false)
    setMedicalModalVisible(true)
  }

  // 从医保目录搜索点击弹窗回填信息
  const getInsuranceRrecordSetFiles = (item: any) => {
    form.setFieldsValue({
      proviceHilistCode: item?.proviceHilistCode, //医保省市编码
      hiListCode: item.hiListCode, //医保国码
      hilistName: (item.hilistName ? item.hilistName : '') + (item.chrgitmLv ? getChrgitmLvName(item.chrgitmLv) : ''), //医保名称 + 甲乙分类
      approvalNumber: item.aprvno, //批准文号
      limitCount: item.limitCount, //医保限量开方

      //顺便回写基础目录信息
      name: writeBack ? item.hilistName : form.getFieldValue('name'),
      mnemonicCode: item?.mnemonicCode, //助记码
      wubiCode: item?.wubiCode, //五笔码
      accountUnit: item.pacunt || form.getFieldValue('accountUnit'),//包装单位
      tenantSupplierName: item.prodentpName || form.getFieldValue('tenantSupplierName'), //生产厂家
      spec: item.spec || form.getFieldValue('spec'), //规格
    })
  }

  // 匹配
  const recordPP = (item: any) => {
    //套用医保限价的价格（当前价格为空时）
    const limitAmount = parseFloat(item.hilistPricUplmtAmt)
    if (
      !isNaN(limitAmount) &&
      limitAmount > 0 &&
      limitAmount < 99999 &&
      !form.getFieldValue('retailPrice')
    ) {
      form.setFieldsValue({
        retailPrice: limitAmount,
      })
    }
    if (form.getFieldValue('hilistPricUplmtAmt') >= 99999) {
      form.setFieldsValue({
        hilistPricUplmtAmt: 0,
      })
    }
    getZjWbCodesAsync(item.hilistName)
    notification.success({ message: '匹配成功！' })
    setMedicalModalVisible(false)
  }

  // 五笔码回填
  const getZjWbCodesAsync = (item: any) => {
    dispatch(getZjWbCodes(item))
      .then(unwrapResult)
      .then((v: any) => {
        form.setFieldsValue({
          mnemonicCode: v?.pinYin,
          wubiCode: v?.wuBi,
        })
      })
  }

  // 注销或启用
  const setStateStatus = (id: any, status: boolean) => {
    const params = status ? {
      id: id, forceRemove: 1
    } : {
      id: id
    }
    dispatch(logoutOrenableCommodity(params))
      .then(unwrapResult)
      .then(() => {
        notification.success({ message: '操作成功' })
        history.push({
          pathname: '/storage/station',
          state: {
            station: '5',
          },
        })
      })
  }

  // 取消
  const returnMessage = () => {
    dispatch(setSelectId(0))
    dispatch(setCommodityDetail({}))
    if (props?.flag == '/homeFlag' || props?.flag == '/msfxFlag') {
      props?.refresh && props?.refresh()
    } else {
      history.push({
        pathname: '/storage/station',
        state: {
          station: '5',
        },
      })
    }
  }

  const scrollToTop = () => {
    setTimeout(() => {
      const leftBar = document.getElementById('sidebar') as HTMLElement
      if (leftBar) {
        leftBar.scrollTop = 0
      }
    }, 100)
  }

  const connectDrugMarkCode = (flag?: boolean) => {
    const value = YPBSMValue || form.getFieldValue('drugMarkCode')
    if (YPBSMValue?.length == 7 || YPBSMValue?.length == 14) {
      // 关联商品标识码
      if (
        !drugMarkCCodeList?.find(
          (d: any) => d == value
        )
      ) {
        setDrugMarkCCodeList(drugMarkCCodeList?.concat(value))
        form.setFieldsValue({ 'drugMarkCode': '' })
        setTimeout(() => {
          drugMarkCodeRef.current?.focus()
        }, 10)
      } else {
        setDrugMarkCCodeList(drugMarkCCodeList)
        form.setFieldsValue({ 'drugMarkCode': '' })
        // setTimeout(() => {
        //   drugMarkCodeRef.current?.focus()
        // }, 10)
      }
    } else {
      if (flag) return
      notification.info({
        message: '无效的识别码',
      })
    }
  }

  return (
    <>
      {props?.materialCategory?.toString() ? (
        <></>
      ) : (
        <Col
          style={{
            margin: '10px 20px',
          }}
        >
          <NavBar
            where={[
              '商品目录',
              JSON.stringify(detail) !== '{}' ? getMaterialsName(materialCategory) + '修改' : getMaterialsName(materialCategory) + '新增',
            ]}
            backtrace={{
              name: '库房工作站',
              path: '/storage/station',
              state: {
                station: '5',
              },
              routeName: '库房工作站',
            }}
            buttons={<></>}
          />
        </Col>
      )}
      <div className={props?.flag == '/msfxFlag' || props?.flag == '/homeFlag' ? styles.elseSaveform : styles.saveform}>
        <Form
          className={styles.formContent}
          {...layout}
          form={form}
          name='control-hooks'
          autoComplete='off'
          layout='vertical'
          onFinishFailed={(v) => {
            if (v?.errorFields?.length) {
              notification.error({
                message: '请输入必填项',
              })
              scrollToTop()
            }
          }}
          onFinish={(vs) => {
            const commonParams = {
              source,
              tenantSupplierId,
              sourceMaterialsCatalogId,
              normalUsemethod: vs.normalUsemethod ? vs.normalUsemethod : '',//常用用法
              drugMarkCode: form.getFieldValue('noTraceCodeFlag') == '1' ? '' : drugMarkCCodeList?.join(',') || '', //商品标识码
              retailPrice: tenantCategory == 17 ? 0 : vs.retailPrice, //售价/元

              spec: vs.spec || '', //规格
              splitTag: vs.splitTag ? 1 : 0, //允许拆零
              splitPrice: vs.splitPrice ? vs.splitPrice : 0, //拆零售价/元
              forceYearAccount: vs.forceYearAccount ? vs.forceYearAccount : 0, //医保结算方式

              // 新增的2个字段
              minPackUnit: undefined, //最小包装单位
              minPackNums: undefined, //最小包装数量

              // 原有但现在页面不展示的字段
              compoundTag: 0, //复方标志
              normalDose: 0,
              useDays: 0,
              genericName: '',
              normalFrequency: 0,
              otc: vs.otc || 0,
              doseCategory: '无',
              stimulantTag: vs.stimulantTag ? 1 : 0,
              ephedrineTag: vs.ephedrineTag ? 1 : 0,
              antibioticTag: vs.antibioticTag ? 1 : 0,
              basicMedicineTag: vs.basicMedicineTag ? 1 : 0,
              skinTestTag: vs.skinTestTag ? 1 : 0,
              splitScale: vs.splitScale ? vs.splitScale : 0,

              // 医保信息
              hilistName: medicalModalInfo?.hilistName, //医保名称
              hiListCode: medicalModalInfo?.hiListCode, //医保代码
              chrgitmLv: medicalModalInfo?.chrgitmLv, //甲乙分类
              // hiListSpec: medicalModalInfo?.hiListSpec, //医保规格
              // prodentpName: medicalModalInfo?.prodentpName, //医保厂家
              // hilistPricUplmtAmt: medicalModalInfo?.hilistPricUplmtAmt, //医保限价
              // pacmatl : medicalModalInfo?.pacmatl, //包装材质
              // pacUnit: medicalModalInfo?.pacUnit, //医保单位
              // memo: medicalModalInfo?.memo, //医保备注
            }

            const saveMappingBody = {
              proviceHilistCode: vs.proviceHilistCode,
              billing_category: vs.billingCategory || '',
              hilist_code: vs.hiListCode || '',
              insuranceCode: insuranceArray[0]?.insuranceCode || '',
              is_reimbursement: medicalModalInfo?.isCouldBx || '',
              limitId: medicalModalInfo?.limitId || '',
              rid: medicalModalInfo?.rid,
            }

            const materialsCatalogPlus = {
              minPackUnit: vs.minPackUnit, //最小包装单位
              minPackNums: vs.minPackNums, //最小包装数量
            }

            const memberInterestVO = tenantCategory == 1 ? {
              discountType: vs.discountType,
              price: vs.memberPrice,
            } : {}

            if (vs.minPackUnit == vs.accountUnit && vs.minPackNums != 1) {
              Modal.warning({
                centered: true,
                title: '提示',
                content: '格式错误，最小包装数量不为1时，包装单位和最小包装单位不能相同',
                okText: '知道了',
                icon: <ExclamationCircleFilled style={{ color: '#faad14' }} />,
              })
              return
            }

            const params = selectId
              ? {
                materialsCatalog: {
                  ...vs,
                  ...commonParams,
                  id: selectId,
                  memberInterestVO: memberInterestVO,
                },
                saveMappingBody: saveMappingBody,
                materialsCatalogPlus: materialsCatalogPlus,
              }
              : {
                materialsCatalog: {
                  ...vs,
                  ...commonParams,
                   memberInterestVO: memberInterestVO,
                },
                saveMappingBody: saveMappingBody,
                materialsCatalogPlus: materialsCatalogPlus,
              }

            setIsSubmitLoading(true)
            dispatch(saveCommodityAsync({ ...params }))
              .then(unwrapResult)
              .then((v?: any) => {
                dispatch(setSelectId(0))
                dispatch(setCommodityDetail({}))
                // 保存并继续
                if (saveAndContinue) {
                  const billingCategory = form.getFieldValue('billingCategory')
                  const drugCategory = form.getFieldValue('drugCategory')
                  resetForm()
                  // 获取药品编码
                  dispatch(getShopGoodsNo())
                  form.setFieldsValue({
                    billingCategory: billingCategory,
                    drugCategory: drugCategory,
                    materialsCategory: materialCategory,
                  })
                } else {
                  if (props?.flag == '/homeFlag' || props?.flag == '/msfxFlag') {
                    props?.refresh && props?.refresh({ ...vs, ...commonParams, materialsCatalogId: v?.materialsCatalogId })
                  } else {
                    history.push({
                      pathname: '/storage/station',
                      state: {
                        station: '5',
                      },
                    })
                  }
                }
              })
              .finally(() => {
                setIsSubmitLoading(false)
              })
          }}
        >
          {/* 码上放心发货单展示信息 */}
          {props?.flag == '/msfxFlag' && JSON.stringify(props?.details) !== '{}' ?
            <Row style={{ position: 'relative', top: '0px', left: '0px', marginBottom: '4px' }}>
              <Col span={24} style={{ width: '100%', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                <span style={{ marginRight: '6px' }}>码上放心发货单</span>
                <span>商品名称：{props?.details?.name}，</span>
                <span>通用名：{props?.details?.genericName}，</span>
                <span>包装规格：{props?.details?.packSpec}，</span>
                <span>批准文号：{props?.details?.approvalNumber}，</span>
                {/* <span>转换比：{props?.details?.transitionScale}，</span> */}
                <span>生产厂家：{props?.details?.tenantSupplierName}</span>
              </Col>
            </Row>
            : ''
          }
          {/* 快捷创建商品 */}
          {JSON.stringify(detail) !== '{}' || selectId ?
            <></> :
            <Col span={15} style={{ display: 'flex' }}>
              <Col className={styles.creatShop}>快捷创建商品</Col>
              <Col
                span={insuranceArray?.length ? 19 : 21}
                style={{ display: 'flex', alignContent: 'center' }}
              >
                <Form.Item
                  {...titleColumnLayout}
                  name='allStr'
                  label=''
                  wrapperCol={{
                    span: 24,
                  }}
                  style={{ width: '100%' }}
                >
                  <RecipeItemInput
                    materialsCategory={materialCategory}
                    source={source}
                    type={ItemCompletionType.Auto}
                    filters={false}
                    defaultUsingSpecifiedBatch={false}
                    onSelect={(m: any) => {
                      setSource(0)
                      setSplitTag(false)
                      recipeItemInputSetFileds(m)
                      setSourceMaterialsCatalogId(m.id)
                      getZjWbCodesAsync(m.name)
                    }}
                  />
                </Form.Item>
                {JSON.stringify(props?.details) != '{}' ? <></> : open && (
                  <Popconfirm
                    title='扫条形码 (69码) 快速添加商品'
                    placement='right'
                    disabled
                    visible={open}
                    onConfirm={() => setOpen(false)}
                    showCancel={false}
                    icon={<CheckCircleOutlined />}
                    okText='我知道了'
                  >
                    <div style={{ marginTop: 15 }}></div>
                  </Popconfirm>
                )}
              </Col>
              {insuranceArray?.length ? (
                <Col style={{ marginLeft: 10 }}>
                  <Button
                    type='primary'
                    ghost
                    style={{ float: 'left' }}
                    onClick={() => {
                      setWriteBack(true)
                      setMedicalModalVisible(true)
                      setComponentItem({
                        name: '',  //商品名称
                        billingCategory: '17', //开票项目 (材料)
                        tenantSupplierName: '', //生产厂家
                        approvalNumber: '', //批准文号
                      })
                    }}
                  >
                    从医保目录搜索
                  </Button>
                </Col>
              ) : <></>}
              {/* <Col >
              <div className={styles.settingFZ}>
                <SettingOutlined
                  style={{
                    fontSize: '20px',
                    color: '#027AFF',
                  }}
                />
                <span className={styles.settingFZText}>赋值设置</span>
              </div>
            </Col> */}
            </Col>}

          {/* 中心内容 */}
          <Row className={styles.centerContent}>
            {/* 左侧内容 */}
            <Col span={tenantCategory == 17 ? 24 : 15} className={props?.flag == '/msfxFlag' || props?.flag == '/homeFlag' ? styles.elseLeftContent : JSON.stringify(detail) !== '{}' ? styles.noSearchleftContent : styles.leftContent} id='sidebar'>
              <div className={styles.titleText}> 商品基本信息</div>
              <Row>
                <Col span={8}>
                  <Form.Item
                    name='no'
                    label='商品编码'
                    rules={[
                      { required: true },
                      {
                        pattern: new RegExp(/^[0-9a-zA-Z]{1,}$/, 'g'),
                        message: '请输入数字或字母',
                      },
                      {
                        max: 20,
                        message: '最长20位',
                      },
                    ]}
                  >
                    <Input
                      size='middle'
                      allowClear
                      disabled={selectId ? true : false}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='name'
                    label='物资名称'
                    rules={[{ required: true }, { max: 45, message: '最长45位!' }]}
                  >
                    <Input
                      size='middle'
                      autoFocus
                      allowClear
                      onInput={(e: any) => {
                        getWubi(e.target.value)
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label='类别'
                  >
                    <Row className={styles.hbCol}>
                      <Col span={9}>
                        <Form.Item name='materialsCategory' >
                          <Select placeholder='' allowClear disabled>
                            {Materiales.map((v) => (
                              <Option value={v} key={v}>
                                {getMaterialsName(v)}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={15}>
                        <Form.Item
                          name='drugCategory'
                        >
                          <Select allowClear={false}>
                            <Option value='材料'>材料</Option>
                            <Option value='器械'>器械</Option>
                            <Option value='消耗品'>消耗品</Option>
                            <Option value='其他'>其他</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='billingCategory'
                    label='开票项目'
                  >
                    <Select
                      placeholder='开票项目'
                      allowClear={false}
                      onChange={(e) => {
                        setComponentItem({
                          ...componentItem,
                          billingCategory: e,
                        })
                      }}
                    >
                      {InvoiceBillingCategories.map((v) => {
                        return (
                          <Option value={v} key={v}>
                            {BillingCategoryName(v)}
                          </Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='approvalNumber'
                    label='批准文号'
                    rules={[{ max: 128, message: '最长128位!' }]}
                  >
                    <Input
                      size='middle'
                      allowClear
                      onChange={(e: any) => {
                        setComponentItem({
                          ...componentItem,
                          approvalNumber: e?.target?.value,
                        })
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name='model' label='型号'>
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='tenantSupplierName'
                    label='生产厂家'
                  >
                    <Input
                      size='middle'
                      allowClear
                      onClick={() => {
                        setIsModalVisible(true)
                      }}
                      onChange={(e: any) => {
                        // 生产厂家有回填 上市许可持有人
                        setComponentItem({
                          ...componentItem,
                          tenantSupplierName: e?.target?.value,
                        })
                        form.setFieldsValue({
                          lstdLicHolder: e?.target?.value,
                        })
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name='lstdLicHolder' label='上市许可持有人'>
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name='normalUsemethod' label='常用用法'>
                    <RecipeItemFieldInput
                      field={'normalUsemethod'}
                      disabled={false}
                      noSize={true}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='spec'
                    label='规格'
                  >
                    <Input size='middle' allowClear
                      onPressEnter={() => {
                        minPackNumsRef.current?.focus()
                      }} />
                  </Form.Item>
                </Col>
                <Col span={8} className={styles.hbCol} style={{ position: 'relative' }}>
                  <div className={styles.unitIcon}> * </div>
                  {/* 对应老的拆零比例+拆零单位 */}
                  <Form.Item
                    label='最小包装数量 ｜ 单位'
                    required={true}
                    rules={[
                      { required: true },
                    ]}
                  >
                    <Row>
                      <Col span={14}>
                        {/* 最小包装数量 */}
                        <Form.Item
                          name='minPackNums'
                          rules={[
                            {
                              required: true,
                              message: '请输入最小包装数量'
                            },
                            {
                              pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                              message: '请输入数字',
                            },
                          ]}
                        >
                          <Input
                            ref={minPackNumsRef}
                            size='middle'
                            allowClear
                            onChange={(e: any) => {
                              return
                            }}
                            onPressEnter={() => {
                              minPackUnitRef.current?.focus()
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        {/* 最小包装单位 */}
                        <Form.Item
                          name='minPackUnit'
                          rules={[
                            {
                              required: true,
                              message: '请选择单位',
                            },
                          ]}
                        >
                          <RecipeItemFieldInput
                            ref={minPackUnitRef}
                            placeholderInput='单位'
                            clearDataFlag={false}
                            field={'doseUnit'}
                            disabled={false}
                            noSize={true}
                            onPressEnter={() => {
                              accountUnitRef.current?.focus()
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Row style={{ position: 'relative' }}>
                    <div className={styles.unitIconCHU}> / </div>
                    <Col span={14}>
                      {/* 对应老的账簿单位 */}
                      <Form.Item
                        name='accountUnit'
                        label='包装单位'
                        rules={[{ required: true }]}
                      >
                        <RecipeItemFieldInput
                          ref={accountUnitRef}
                          field={'accountUnit'}
                          disabled={false}
                          noSize={true}
                        />
                      </Form.Item>
                    </Col>
                    <Popover
                      title='示例'
                      content={
                        <div>
                          <img
                            src={ElseImg}
                            style={{ width: '500px' }}
                            alt=''
                          />
                        </div>
                      }
                      placement='bottom'
                    >
                      <Col span={10} className={styles.bzdwTips}>查看示例</Col>
                    </Popover>
                  </Row>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='barCode'
                    label='条形码'
                    rules={[{ max: 35, message: '最长35位!' }]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ position: 'relative' }}>
                  <Form.Item
                    label='商品标识码(追溯码前7位)'
                    rules={[
                      {
                        pattern: new RegExp(/^[a-zA-Z0-9,]*$/, 'g'),
                        message: '请输入正确的标识码',
                      },
                    ]}
                  >
                    <Row className={styles.hbCol}>
                      <Col span={7}>
                        <Form.Item name='noTraceCodeFlag'>
                          <Select placeholder='' >
                            <Option value={'0'} key={'0'}>
                              有码
                            </Option>
                            <Option value={'1'} key={'1'}>
                              无码
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={17} className={styles.addonAfterButton} style={{ position: 'relative' }}>
                        <Dropdown
                          overlay={spbsmOverlay}
                          visible={isSPBSMVisible}
                          onVisibleChange={(v) => {
                            if (!v) {
                              setIsSPBSMVisible(v);
                            }
                          }}
                        >
                          <Form.Item
                            name='drugMarkCode'
                            rules={[
                              {
                                pattern: new RegExp(/^[a-zA-Z0-9,]*$/, 'g'),
                                message: '请输入数字或字母',
                              },
                            ]}>
                            <Input
                              ref={drugMarkCodeRef}
                              placeholder={drugMarkCCodePlaceholder}
                              size='middle'
                              allowClear={false}
                              maxLength={50}
                              addonAfter={
                                <>
                                  {showGLButton && (
                                    <Button
                                      type='primary'
                                      ghost
                                      onClick={(() => {
                                        connectDrugMarkCode(true)
                                      })}
                                    >关联</Button>)
                                  }
                                </>
                              }
                              onFocus={() => {
                                // 光标选中展示placeholder
                                setDrugMarkCCodePlaceholder('扫描或输入前7位')
                              }}
                              onBlur={() => {
                                // 失焦不展示placeholder
                                setDrugMarkCCodePlaceholder('')
                                connectDrugMarkCode()
                                form.setFieldsValue({
                                  drugMarkCode: drugMarkCCodeList?.[0]
                                })
                              }}
                              onPressEnter={(() => {
                                connectDrugMarkCode()
                              })}
                              onClick={() => {
                                // 点击输入框展示弹窗
                                if (drugMarkCCodeList?.length) {
                                  setIsSPBSMVisible(true)
                                  form.setFieldsValue({
                                    drugMarkCode: ''
                                  })
                                }
                              }}
                              onChange={((e) => {
                                const value = e?.target?.value
                                setYPBSMValue(value)
                                if (value) {
                                  // 输入中展示关联按钮
                                  setShowGLButton(true)
                                } else {
                                  // 输入为空不展示关联按钮
                                  setShowGLButton(false)
                                }
                              })}
                            /></Form.Item>
                        </Dropdown>
                        {(drugMarkCCodeList?.length && drugMarkCCodeList?.length > 1 && !showGLButton) ? (
                          <span style={{ color: '#07C160', position: 'absolute', right: '12px', top: '5px' }}>
                            +{drugMarkCCodeList?.length - 1}
                          </span>
                        ) : ''}
                      </Col>
                    </Row>
                  </Form.Item>
                  <Popover
                    title='药品标识码'
                    content={
                      <div>
                        <p>
                          药品标志码为药品追溯码的前一部分代码，当您维护此编码后，系统会在上传追溯码时为您校验
                          <span style={{ fontWeight: 'bold' }}>
                            是否扫错码
                          </span>
                          。
                        </p>
                        <p>一般情况下</p>
                        <p>
                          追溯码为
                          <span
                            style={{ color: '#068b39', fontWeight: 'bold' }}
                          >
                            20位
                          </span>
                          的药品，药品标志码为
                          <span
                            style={{ color: '#068b39', fontWeight: 'bold' }}
                          >
                            前7位
                          </span>
                        </p>
                        <p>
                          <span
                            style={{ color: '#d33f0e', fontWeight: 'bold' }}
                          >
                            超过20位
                          </span>
                          的长追溯码（部分进口药），药品标志码为
                          <span
                            style={{ color: '#d33f0e', fontWeight: 'bold' }}
                          >
                            前14位
                          </span>
                        </p>
                        <p>
                          如果同个品种存在多个标识码，可以用英文逗号隔开。您可以不用手动填写此代码，<span
                            style={{ color: '#068b39', fontWeight: 'bold' }}
                          >
                            系统将在你扫码时自动更新该信息。
                          </span>
                        </p>
                        <p>
                          <img
                            src={DrugImg}
                            style={{ width: '300px' }}
                            alt=''
                          />
                        </p>
                        <p>有码无码：如果药品包装上无追溯码，可将该药品标记为“无码药品”，发药、入库时无需扫码采集。医保监管要求应采尽采，药品有追溯码但设置成无码，可能会存在监管处罚风险。</p>
                      </div>
                    }
                    placement='bottom'
                  >
                    <span className={styles.tips}>示例</span>
                  </Popover>
                </Col>
              </Row>
              <div className={styles.titleTexts}>
                <span style={{ fontWeight: 'bold' }}>扩展信息</span>
                <span
                  className={styles.iconMain}
                  onClick={() => {
                    setExtendInformation(!extendInformation)
                  }}
                >
                  <span>{!extendInformation ? '展开' : '收起'}</span>
                  {!extendInformation ? (
                    <CaretDownFilled className={styles.icon} />
                  ) : (
                    <CaretUpFilled className={styles.icon} />
                  )}
                </span>
              </div>
              <Row style={{ display: extendInformation ? undefined : 'none' }}>
                <Col span={8} style={{ position: 'relative' }}>
                  <Form.Item
                    name='mnemonicCode'
                    label='助记码'
                    rules={[
                      {
                        max: 40,
                        message: '最长40位!',
                      },
                    ]}
                  >
                    <Input size='middle' allowClear
                    />
                  </Form.Item>
                  <Popover
                    content={
                      <div>
                        <p>
                          是指物资名称的拼音首字母，系统自动生成，设置后支持用助记码去搜索该商品
                        </p>
                      </div>
                    }
                    placement='bottom'
                    title='说明'
                  >
                    <img src={QuestionTipsImg} className={styles.questionTips3} />
                  </Popover>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='wubiCode'
                    label='五笔码'
                    rules={[
                      {
                        max: 40,
                        message: '最长40位!',
                      },
                    ]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name='origin' label='产地' >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ position: 'relative' }}>
                  {/* 第三方编号对应老的其他编号 */}
                  <Form.Item
                    name='miscNo'
                    label='第三方编号'
                    rules={[{ max: 40, message: '最长40位!' }]}
                  >
                    <Input
                      size='middle'
                      allowClear
                    />
                  </Form.Item>
                  <Popover
                    content={
                      <div>
                        <p>
                          主要用于购入入库导入库存时导入的商品和目录做关联。
                        </p>
                      </div>
                    }
                    placement='bottom'
                    title='说明'
                  >
                    <img src={QuestionTipsImg} className={styles.questionTips5} />
                  </Popover>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='tradeRemark'
                    label='注册商标'
                    rules={[{ max: 128, message: '最长128位!' }]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='productionLicence'
                    label='生产许可证'
                    rules={[{ max: 128, message: '最长128位!' }]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            {/* 右侧内容 */}
            {/* 校医务室药品不展示 */}
            {tenantCategory == 17 ? <></> :
              <>
                <Col span={9} className={props?.flag == '/msfxFlag' || props?.flag == '/homeFlag' ? styles.elseRightContent : JSON.stringify(detail) !== '{}' ? styles.noSearchrightContent : styles.rightContent}>
                  <Row className={styles.rightContentTitle}>
                    <Col span={6} className={styles.titleText}>价格信息</Col>
                    <Col span={18} className={styles.titleButton}>
                      {/* 医保机构且有医保名称才展示 */}
                      {form.getFieldValue('hilistName') && insuranceArray.length ? (
                        <Button type="primary" size="middle" ghost style={{ marginRight: '10px' }}
                          onClick={() => {
                            const hilistPricUplmtAmtFromGet = form.getFieldValue('hilistPricUplmtAmt')
                            const hilistPricUplmtAmt = hilistPricUplmtAmtFromGet >= 99999 || hilistPricUplmtAmtFromGet == 0
                            if (hilistPricUplmtAmt) {
                              return
                            } else {
                              form.setFieldsValue({
                                retailPrice: hilistPricUplmtAmtFromGet,
                              })
                            }
                          }}
                        >同步限价到售价</Button>
                      ) : <></>}
                      {/* 没有勾选零库存开单展示 */}
                      {detail?.id && !settings?.[Checks.Lkcky] ? (
                        <Button type="primary" size="middle" ghost
                          onClick={() => {
                            setSureVisible(true)
                          }}
                        >同步售价到库存</Button>
                      ) :
                        <></>}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12} style={{ position: 'relative' }}>
                      <Form.Item
                        name='retailPrice'
                        label='售价/元'
                        rules={[
                          { required: true },
                          {
                            pattern: new RegExp(/^\d+(\.\d{1,5})?$/, 'g'),
                            message: '请输入保留小数五位以内的数',
                          },
                        ]}
                      >
                        <Input size='middle' allowClear />
                      </Form.Item>
                      <Col className={styles.splitTag}>
                        <Form.Item name='splitTag' valuePropName='checked'>
                          <Checkbox
                            style={{ width: '100px' }}
                            onChange={((e) => {
                              setSplitTag(e.target.checked)
                            })}>允许拆零</Checkbox>
                        </Form.Item>
                      </Col>

                    </Col>
                    {/* 勾选了允许拆零才显示拆零售价 */}
                    {splitTag ?
                      <Col span={12}>
                        <Form.Item
                          name='splitPrice'
                          label='拆零售价/元'
                          rules={[{ required: true }]}
                        >
                          <Input size='middle' allowClear />
                        </Form.Item>
                      </Col>
                      : <></>}
                    <Col span={12}>
                      <Form.Item
                        name='stockPrice'
                        label='进价/元'
                        rules={[
                          {
                            pattern: new RegExp(/^\d+(\.\d{1,5})?$/, 'g'),
                            message: '请输入保留小数五位以内的数',
                          },
                        ]}
                      >
                        <Input size='middle' allowClear />
                      </Form.Item>
                    </Col>
                    <Col span={12} style={{ position: 'relative' }}>
                      <Form.Item
                        name='tax'
                        label='项目税率'
                        rules={[
                          {
                            pattern: new RegExp(/^(0(\.\d{1,2})?|1(\.0{1,2})?)$/),
                            message: '请输入0~1之间的数字，支持小数点后两位',
                          },
                        ]}
                      >
                        <Input size='middle' />
                      </Form.Item>
                      <Popover
                        content={
                          <div>
                            <p>
                              如果您接入了电子发票，且需要控制每个项目的税率，可以在此处填写该项目的税率，如果您属于免税机构，则不需要填写。
                            </p>
                            <p>
                              如果您需要批量修改所有项目的税率，也可与我们的服务人员联系。
                            </p>
                            <p>格式为：0~1，保留2位小数点，如0.03</p>
                          </div>
                        }
                        placement='bottom'
                        title='说明'
                      >
                        <img src={QuestionTipsImg} className={styles.questionTips4} />
                      </Popover>
                    </Col>
                    {/* 1 药店 */}
                    {tenantCategory == 1 ?
                      <Col span={12}>
                        <Form.Item
                          {...firstColumnLayout}
                          label='会员价'
                        >
                          <Row className={styles.hbCol}>
                            <Col span={7}>
                              <Form.Item name='discountType' noStyle initialValue={0}>
                                <Select
                                  onChange={(val) => {
                                    const memberPrice = form.getFieldValue('memberPrice')
                                    if (memberDiscountType === 0 && val === 1) {
                                      // 折扣 → 特价
                                      setCachedDiscountPrice(memberPrice)
                                      form.setFieldsValue({ memberPrice: cachedSpecialPrice ?? undefined })
                                    } else if (memberDiscountType === 1 && val === 0) {
                                      // 特价 → 折扣
                                      setCachedSpecialPrice(memberPrice)
                                      form.setFieldsValue({ memberPrice: cachedDiscountPrice ?? undefined })
                                    }
                                    setMemberDiscountType(val)
                                  }}
                                >
                                  <Select.Option value={0}>折扣</Select.Option>
                                  <Select.Option value={1}>特价</Select.Option>
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col span={17}>
                              <Form.Item
                                name='memberPrice'
                                noStyle
                                rules={[
                                  memberDiscountType === 1
                                    ? {
                                      pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,5})?$/),
                                      message: '请输入数字，支持小数点后五位',
                                    }
                                    : {
                                      pattern: new RegExp(/^(100|[1-9]?\d)$/),
                                      message: '折扣请输入0-100的整数',
                                    },
                                ]}
                              >
                                <Input
                                  size='middle'
                                  allowClear
                                  addonAfter={memberDiscountType === 1 ? '元' : '%'}
                                  onBlur={(e) => {
                                    if (memberDiscountType === 1 && e.target.value) {
                                      const num = Number(e.target.value)
                                      if (!isNaN(num)) {
                                        form.setFieldsValue({ memberPrice: num.toFixed(5) })
                                      }
                                    }
                                  }}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Form.Item>
                      </Col> :
                      <></>
                    }
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={12} className={styles.titleText}>医保匹配信息</Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ position: 'relative' }} className={styles.matchInfo}>
                      <Form.Item
                        label='医保对码'
                      >
                        <Row className={styles.hbYDMCol} >
                          <Col span={12}>
                            <Form.Item name='hilistName'>
                              <Input
                                size='middle'
                                disabled
                                style={{ textAlign: 'left' }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item name='hiListCode'>
                              <Input
                                style={{ textAlign: 'right', fontSize: '12px', height: '30px' }}
                                size='middle'
                                disabled
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form.Item>
                      <span className={styles.tips} style={{ cursor: 'pointer' }} onClick={(() => {
                        matching()
                      })}>{form.getFieldValue('hilistName') ? '重新匹配' : '立即匹配'}</span>
                    </Col>
                    <Col span={12} style={{ position: 'relative' }}>
                      <Form.Item
                        name='rewriteHilistCode'
                        label='自定义医保国码'
                      >
                        <Input size='middle' />
                      </Form.Item>
                      <Popover
                        content={
                          <div>
                            <p>
                              当您知道此项目的医保国家编码，而医保匹配又搜索不到该项目时，您可以跳过匹配并直接填写医保国家编码。
                            </p>
                            <p>
                              在编码正确的情况下仍可进行医保结算；系统将会优先使用自定义医保国码进行医保结算。
                            </p>
                            <p>
                              请注意：使用自定义医保国码时，编码的限价与甲乙分类将不能正确展示，但不会影响医保刷卡与报销。
                            </p>
                          </div>
                        }
                        placement='bottom'
                        title='说明'
                      >
                        <img src={QuestionTipsImg} className={styles.questionTips7} />
                      </Popover>
                    </Col>
                    <Col span={12} style={{ position: 'relative' }}>
                      <Form.Item
                        name='proviceHilistCode'
                        label='医保省市编码'
                      >
                        <Input size='middle' />
                      </Form.Item>
                      <Popover
                        content={
                          <div>
                            <p>
                              部分项目必须国码配合省码一起上传才可以进入医保报销。
                            </p>
                            <p>
                              如果有需要指定省码的项目，请将省码填写到这里，例如血液透析仪的省码为：”cl311000100x“。
                            </p>
                            <p>
                              请注意：不需要传省码的项目请不要填写，以免影响报销；若有疑问，您可以联系客服人员。
                            </p>
                          </div>
                        }
                        placement='bottom'
                        title='说明'
                      >
                        <img src={QuestionTipsImg} className={styles.questionTips6} />
                      </Popover>
                    </Col>
                    <Col span={12} style={{ position: 'relative' }}>
                      <Form.Item
                        name='limitCount'
                        label='医保限量开方'
                        rules={[
                          {
                            pattern: /^\d+(\.\d{1,2})?$/,
                            message: '请输入数字（最多两位小数）',
                          },
                        ]}
                      >
                        <Input size='middle' />
                      </Form.Item>
                      <Popover
                        content={
                          <div>
                            <p>当您设置了医保限量开方数量后，如果该商品</p>
                            <p>在医保结算时数量超过了设置的医保限量时，</p>
                            <p>
                              超出部分会
                              <a style={{ color: 'red' }}>
                                自动转为自费结算，且不会传给医保。
                              </a>
                            </p>
                            <p>若类型为中草药时，限量为每贴数量。</p>
                            <p>
                              <a style={{ color: 'grey' }}>
                                该功能不支持拆零，不设置即不启用。
                              </a>
                            </p>
                          </div>
                        }
                        placement='bottom'
                        title='说明'
                      >
                        <img src={QuestionTipsImg} className={styles.questionTips6} />
                      </Popover>
                    </Col>
                  </Row>
                  {form.getFieldValue('hilistName') ? <>
                    <Row className={styles.ybMessage}>
                      <Col span={24} className={styles.ybMessageItem}>医保规格：{medicalModalInfo?.spec}</Col>
                      <Col span={12} className={styles.ybMessageItem}>准字：{medicalModalInfo?.aprvno}</Col>
                      <Col span={12} className={styles.ybMessageItem}>厂家：{medicalModalInfo?.prodentpName}</Col>
                      {medicalModalInfo?.pacmatl ? <Popover
                        placement='top'
                        content={<div style={{ maxWidth: '500px' }}>{medicalModalInfo?.pacmatl}</div>}
                      >
                        <Col span={12} className={styles.ybMessageItem}>包装材质：{medicalModalInfo?.pacmatl}</Col>
                      </Popover> : <Col span={12} className={styles.ybMessageItem}>包装材质：{medicalModalInfo?.pacmatl}</Col>}
                      <Col span={12} className={styles.ybMessageItem}>限价：{medicalModalInfo?.hilistPricUplmtAmt}</Col>
                      <Col span={24} className={styles.ybMessageItem}>自付比例信息：{medicalModalInfo?.zfblDescription}</Col>
                      {cityCode?.indexOf('32') == 0 ? <Col span={24} style={{ lineHeight: '26px' }}>挂网价:{medicalModalInfo?.onlinePrice}</Col> : ''}
                      <Col span={24} className={styles.ybMessageItem}>备注：{medicalModalInfo?.memo}</Col>
                    </Row>
                  </> : <></>}
                  <Row style={{ marginTop: '6px' }}>
                    <Col span={24} className={styles.ybjsfsMessage}>
                      <Row style={{ display: 'flex', alignItems: 'center' }}>
                        <span className={styles.jlTitle} style={{ width: '98px', lineHeight: '32px' }}>医保结算方式：</span>
                        <Form.Item
                          name='forceYearAccount'
                        >
                          <Radio.Group
                            defaultValue={0}
                            style={{ width: '400px' }}
                          >
                            <Radio value={0}>优先统筹</Radio>
                            <Radio value={1}>优先个账（包含本年、历年）</Radio>
                            <Radio value={2}>自费</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </>}
          </Row>
        </Form>
        <div className={styles.bottomContent} style={{ position: 'relative' }}>
          {/* 编辑展示 */}
          {JSON.stringify(detail) != '{}' ? (
            <>
              {detail?.state == 1 ?
                <Popconfirm
                  title={'确认进行注销操作吗？'}
                  onConfirm={() => {
                    setStateStatus(detail.id, true)
                  }}
                  onCancel={() => {
                    setStateStatus(detail.id, false)
                  }}
                  okText='确认并同步删除套餐/未收费处方'
                  //取消按钮当做注销，确认按钮当做强行注销
                  cancelButtonProps={{
                    style: {
                      border: 0,
                      backgroundColor: '#027AFF',
                      color: '#FFF',
                    },
                  }}
                  okButtonProps={{
                    style: {
                      border: 0,
                      backgroundColor: '#fe2121',
                      color: '#FFF',
                    },
                  }}
                  cancelText='确认'
                >
                  <Button type="primary" ghost danger style={{ position: 'absolute', left: '20px' }}>注销</Button>
                </Popconfirm> :
                <Popconfirm
                  title={'确认进行启用操作？'}
                  onConfirm={() => {
                    setStateStatus(detail.id, false)
                  }}
                  onCancel={() => {
                    return
                  }}
                  okText='确认'
                  cancelText='取消'
                >
                  <Button type="primary" ghost style={{ position: 'absolute', left: '20px' }}>启用</Button>
                </Popconfirm>
              }
            </>
          ) : (
            <></>
          )}
          <Button
            style={{ marginRight: '10px' }}
            onClick={(() => {
              returnMessage()
            })}
          >
            取消
          </Button>
          <Button
            type="primary"
            loading={isSubmitLoading}
            style={{ marginRight: '10px' }}
            onClick={(() => {
              form.submit()
              setSaveAndContinue(false)
            })}>
            保存
          </Button>
          {/* 新增展示保存并继续 */}
          {JSON.stringify(detail) != '{}' || props?.flag == '/msfxFlag' || props?.flag == '/homeFlag' ? (
            <></>
          ) : <Button
            loading={isSubmitLoading}
            onClick={(() => {
              form.submit()
              setSaveAndContinue(true)
            })}>
            保存并继续
          </Button>}
        </div>
        {/* 生产厂家 supplierCategory=1  供应商 supplierCategory=0*/}
        <SupplierModal
          supplierCategory={1}
          visible={isModalVisible}
          switchModal={() => {
            setIsModalVisible(false)
            setIsAddModalVisible(true)
          }}
          onOk={() => {
            setIsModalVisible(false)
          }}
          onCancel={() => {
            setIsModalVisible(false)
          }}
          onRecord={(record: any) => {
            setTenantSupplierId(record.id)
            form.setFieldsValue({
              tenantSupplierName: record.companyName,
              lstdLicHolder: record.companyName,
            })
          }}
        />
        {/* 新增供应商 */}
        <SupplierSaveModal
          visible={isAddModalVisible}
          supplierCategory={1}
          onOk={() => {
            setIsAddModalVisible(false)
            dispatch(setCurrent(1))
            dispatch(setSelectId(0))
            setIsModalVisible(true)
          }}
          onCancel={() => {
            setIsAddModalVisible(false)
            setIsModalVisible(true)
            dispatch(setSelectId(0))
          }}
        />
        {/* 从医保目录搜索 */}
        <MedicalModal
          visible={medicalModalVisible}
          onOk={() => {
            setMedicalModalVisible(false)
          }}
          onCancel={() => {
            setMedicalModalVisible(false)
          }}
          onRecord={(item) => {
            setMedicalModalInfo(item)
            getInsuranceRrecordSetFiles({
              ...item,
            })
            recordPP(item)
          }}
          componentItem={{
            ...componentItem,
            insuranceCode: insuranceArray.length
              ? insuranceArray[0].insuranceCode
              : '',
          }}
        />
        <Modal
          width={500}
          title='确认操作'
          confirmLoading={loading}
          destroyOnClose
          visible={sureVisible}
          onCancel={() => setSureVisible(false)}
          onOk={() => {
            setLoading(true)
            const params = {
              id: detail?.id,
              stockPrice: form.getFieldValue('stockPrice'),
              retailPrice: form.getFieldValue('retailPrice'),
              flag: isChecked ? 1 : 0,
            }
            dispatch(getSyncInventoryAsync(params))
              .then(unwrapResult)
              .then((v: any) => {
                notification.success({
                  message: v,
                })
              })
              .finally(() => {
                setLoading(false)
                setSureVisible(false)
              })
          }}
        >
          <div style={{ paddingLeft: '10px' }}>
            <div style={{ display: 'flex' }}>
              <ExclamationCircleFilled
                style={{
                  color: '#FFAE55',
                  fontSize: 18,
                }}
              />
              <div style={{ margin: '-4px 0 0 10px' }}>
                <div>
                  是否给该商品的所有库存价格调整为：售价
                  {form.getFieldValue('retailPrice')}元
                </div>
                <div>如需生成变动记录，请在左下角勾选上生成变动记录</div>
              </div>
            </div>
            <Checkbox
              checked={isChecked}
              onChange={() => {
                setIsChecked(!isChecked)
                localStorage.setItem('SFSCBDJLHTJJL', JSON.stringify(!isChecked))
              }}
              style={{ margin: '10px 0', position: 'absolute', bottom: '4px' }}
            >
              生成调价记录
            </Checkbox>
          </div>
        </Modal>
      </div >
    </>
  )
}
